import PromotionGiftReturnModal from '../../components/promotions/PromotionGiftReturnModal';
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import axios from "axios";
import * as XLSX from "xlsx";
import Flatpickr from "flatpickr";
import { Spanish } from "flatpickr/dist/l10n/es.js";
import "flatpickr/dist/themes/material_green.css";
const api = axios.create({ baseURL: process.env.REACT_APP_API || "" });
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});
import "../../styles/PromotionsAdmin.css";

const initial = {
  name: "",
  starts_on: "",
  ends_on: "",
  allow_cash: true,
  allow_credit: true,
  sedes: [],
  products: [],
};
const unwrap = (response) => response?.data?.data || [];
export default function PromotionsAdmin({ meta = {} }) {
  const [returnOpen,setReturnOpen] = useState(false);
  const [createOpen,setCreateOpen] = useState(false);
  const [reportCampaign,setReportCampaign] = useState(null);
  const [report,setReport] = useState(null);
  const [reportError,setReportError] = useState("");
  const [tab,setTab] = useState('ACTIVE');
  const [period,setPeriod] = useState('range');
  const today=()=>{
    const parts=new Intl.DateTimeFormat('en-US',{timeZone:'America/Lima',year:'numeric',month:'2-digit',day:'2-digit'}).formatToParts(new Date());
    const get=type=>parts.find(part=>part.type===type)?.value;
    return `${get('year')}-${get('month')}-${get('day')}`;
  };
  const asLocalDate=value=>{
    const match=/^(\d{4})-(\d{2})-(\d{2})$/.exec(String(value||''));
    return match?new Date(Number(match[1]),Number(match[2])-1,Number(match[3])):null;
  };
  const [from,setFrom] = useState(()=>today().slice(0,8)+'01');
  const [to,setTo] = useState(()=>today());
  const [search,setSearch] = useState('');
  const [sedeFilter,setSedeFilter] = useState('');
  const [advisorFilter,setAdvisorFilter] = useState('');
  const [rucFilter,setRucFilter] = useState('');
  const [categoryFilter,setCategoryFilter] = useState('');
  const [supplierFilter,setSupplierFilter] = useState('');
  const [filterOptions,setFilterOptions] = useState({advisors:[],rucs:[],categories:[],suppliers:[]});
  const rangeRef=useRef(null);
  const dayRef=useRef(null);
  // No sobrescribir rangos seleccionados manualmente al actualizar campañas.
  const manualPeriodRef=useRef(false);
  const initialPeriodAppliedRef=useRef(false);
  const [items, setItems] = useState([]),
    [form, setForm] = useState(initial);
  const [busy, setBusy] = useState(false),
    [error, setError] = useState(""),
    [notice, setNotice] = useState("");
  const sedes = meta.sedes || [];
  const [products,setProducts] = useState([]);
  const [catalogBusy,setCatalogBusy] = useState(false);
  const [productSearch,setProductSearch] = useState("");
  const startRef=useRef(null),endRef=useRef(null);
  useEffect(()=>{
    const input=period==='range'?rangeRef.current:period==='day'?dayRef.current:null;
    if(!input)return;
    const format=d=>`${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}`;
    // Flatpickr receives Date objects, not ISO strings interpreted using d/m/Y.
    const first=asLocalDate(from),last=asLocalDate(to);
    const defaults=period==='range'?[first,last].filter(Boolean):[last].filter(Boolean);
    const fp=Flatpickr(input,{
      locale:Spanish,
      mode:period==='range'?'range':'single',
      dateFormat:'d/m/Y',
      disableMobile:true,
      allowInput:false,
      defaultDate:defaults,
      onChange:dates=>{
        if(period==='range'&&dates.length===2){
          const [start,end]=dates;
          manualPeriodRef.current=true;
          setFrom(format(start));
          setTo(format(end));
        }else if(period==='day'&&dates.length===1){
          const selected=format(dates[0]);
          manualPeriodRef.current=true;
          setFrom(selected);
          setTo(selected);
        }
      }
    });
    return ()=>fp.destroy();
  },[period]);
  useEffect(()=>{
    if(!createOpen)return;
    const instances=[startRef,endRef].map((ref,index)=>Flatpickr(ref.current,{
      locale:Spanish,dateFormat:"Y-m-d",allowInput:false,disableMobile:true,
      onChange:(_,date)=>setForm(f=>({...f,[index===0?"starts_on":"ends_on"]:date}))
    }));
    return ()=>instances.forEach(instance=>instance.destroy());
  },[createOpen]);
  useEffect(()=>{
    let active=true;setCatalogBusy(true);
    api.get("/promotions/catalog").then(response=>{
      if(active)setProducts(unwrap(response));
    }).catch(()=>{if(active)setError("No se pudo cargar el catálogo MERCH / REGALOS. Revisa la conexión con el backend.");})
    .finally(()=>{if(active)setCatalogBusy(false)});
    return ()=>{active=false};
  },[]);
  const sedeIds=sedes.map(s=>Number(s.sd_id||s.id));
  const allSedesSelected=sedeIds.length>0&&sedeIds.every(id=>form.sedes.includes(id));
  const filteredProducts=products.filter(p=>`${p.title} ${p.category}`.toLowerCase().includes(productSearch.toLowerCase()));
  const load = useCallback(async () => {
    try {
      setError("");
      const campaigns = unwrap(await api.get("/promotions"));
      // Solo la primera carga establece el rango sugerido. Los cambios manuales
      // y las actualizaciones posteriores conservan el periodo elegido.
      if (!initialPeriodAppliedRef.current && !manualPeriodRef.current) {
        initialPeriodAppliedRef.current = true;
        const currentDay = today();
        const firstOfMonth = `${currentDay.slice(0, 7)}-01`;
        const activeStarts = (Array.isArray(campaigns) ? campaigns : [])
          .filter(c => {
            const start = String(c.starts_at || c.starts_on || '').slice(0, 10);
            const end = String(c.ends_at || c.ends_on || '').slice(0, 10);
            return c.status === 'ACTIVE' && /^\d{4}-\d{2}-\d{2}$/.test(start)
              && /^\d{4}-\d{2}-\d{2}$/.test(end)
              && start <= currentDay && end >= currentDay;
          })
          .map(c => String(c.starts_at || c.starts_on).slice(0, 10));
        const suggestedFrom = activeStarts.length
          ? activeStarts.reduce((earliest, value) => value < earliest ? value : earliest)
          : firstOfMonth;
        setFrom(suggestedFrom);
        setTo(currentDay);
        // El calendario ya está montado: actualizar también su valor visible.
        if (rangeRef.current?._flatpickr) {
          rangeRef.current._flatpickr.setDate(
            [asLocalDate(suggestedFrom), asLocalDate(currentDay)], false
          );
        }
      }
      setItems(campaigns);
    } catch (e) {
      setError(
        e.response?.data?.error || "No se pudieron consultar las promociones",
      );
    }
  }, []);
  useEffect(() => {
    load();
  }, [load]);
  const selected = useMemo(
    () => new Set(form.products.map(Number)),
    [form.products],
  );
  const toggle = (key, id) =>
    setForm((f) => ({
      ...f,
      [key]: f[key].includes(id)
        ? f[key].filter((v) => v !== id)
        : [...f[key], id],
    }));
  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setNotice("");
    if (
      !form.name.trim() ||
      !form.starts_on ||
      !form.ends_on ||
      form.ends_on < form.starts_on ||
      !form.sedes.length ||
      !form.products.length ||
      (!form.allow_cash && !form.allow_credit)
    ) {
      setError("Completa nombre, fechas, modalidades, sedes y productos.");
      return;
    }
    setBusy(true);
    try {
      await api.post("/promotions", form);
      setForm({...initial});
      [startRef,endRef].forEach(ref=>ref.current?._flatpickr?.clear());
      setNotice("Campaña registrada correctamente");setCreateOpen(false);
      await load();
    } catch (e) {
      setError(e.response?.data?.error || "No se pudo crear la campaña");
    } finally {
      setBusy(false);
    }
  };
  const status = async (id, value) => {
    setBusy(true);
    setError("");
    try {
      await api.patch(`/promotions/${id}/status`, { status: value });
      await load();
    } catch (e) {
      setError(e.response?.data?.error || "No se pudo cambiar el estado");
    } finally {
      setBusy(false);
    }
  };
  useEffect(()=>{api.get('/promotions/report-filters').then(r=>setFilterOptions(r.data.data)).catch(()=>{});},[]);
  const reportParams=useMemo(()=>({...(period==='range'?{from,to}:period==='day'?{from:to,to}:{}),...(sedeFilter?{sede_id:sedeFilter}:{}),...(advisorFilter?{advisor_id:advisorFilter}:{}),...(rucFilter?{ruc_id:rucFilter}:{}),...(categoryFilter?{category_id:categoryFilter}:{}),...(supplierFilter?{supplier_id:supplierFilter}:{}),...(search.trim()?{search:search.trim()}: {})}),[period,from,to,sedeFilter,advisorFilter,rucFilter,categoryFilter,supplierFilter,search]);
  const fetchReport=useCallback(async(id,params)=>{try{const r=await api.get(`/promotions/${id}/report`,{params});setReport(r.data.data);setReportError('');}catch(e){setReportError(e.response?.data?.error||'No se pudo consultar el reporte');}},[]);
  useEffect(()=>{if(!reportCampaign)return;fetchReport(reportCampaign.id,reportParams);const timer=setInterval(()=>fetchReport(reportCampaign.id,reportParams),20000);return ()=>clearInterval(timer);},[reportCampaign,reportParams,fetchReport]);
  const exportReport=()=>{if(!report)return;const wb=XLSX.utils.book_new(),rows=report.rows;
    const add=(name,arr)=>XLSX.utils.book_append_sheet(wb,XLSX.utils.json_to_sheet(arr.length?arr:[{Resultado:'Sin registros'}]),name);
    add('Resumen',[{Campaña:report.campaign.name,Entregados:report.summary.delivered,Devueltos:report.summary.returned,Anulados:report.summary.voided,Netos:report.summary.net}]);
    const group=(field)=>Object.values(rows.reduce((acc,r)=>{const name=String(r[field]||'Sin dato');if(!acc[name])acc[name]={Nombre:name,Entregados:0,Devueltos:0,Anulados:0};const q=Number(r.quantity)||0;acc[name].Entregados+=q;if(r.status==='RETURNED')acc[name].Devueltos+=q;if(r.status==='VOIDED')acc[name].Anulados+=q;return acc;},{})).map(x=>({...x,Netos:x.Entregados-x.Devueltos-x.Anulados}));
    add('Productos',group('product'));add('Sedes',group('sede'));add('Asesores',group('advisor'));add('RUC',group('issuer'));
    add('Detalle',rows.map(r=>({Fecha:r.created_at,Cliente:r.customer,DNI:r.dni,Asesor:r.advisor,Sede:r.sede,RUC:r.issuer,Comprobante:r.document_number,Producto:r.product,Categoria:r.category,Proveedor:r.supplier,Cantidad:r.quantity,Estado:r.status,Registro:r.register_id})));
    XLSX.writeFile(wb,`campana_${report.campaign.id}_reporte.xlsx`);
  };
  const filteredItems=items.filter(p=>p.status===tab&&(period==='all'||(String(p.starts_at).slice(0,10)<=to&&String(p.ends_at).slice(0,10)>=(period==='day'?to:from))));
  return (
    <section
      className="mp-promotions"
      aria-label="Administración de promociones"
    >
      <header><div><h2>Campañas promocionales</h2><p>Gestión y trazabilidad de MERCH / REGALOS.</p></div><div className="mp-promo-actions"><button type="button" onClick={load}>Actualizar</button><button type="button" className="mp-promotions-primary" onClick={()=>setCreateOpen(true)}>+ Nueva campaña</button></div></header>
      <div className="mp-promo-filters">
        <div className="mp-promo-filter-top">
          <div className="mp-promo-period-field">
            <strong>PERIODO</strong>
            <div className="mp-promo-period-controls">
              <div className="mp-promo-period-switch" role="group" aria-label="Periodo de consulta">
                {[['all','Todos'],['day','1 día'],['range','Rango']].map(([v,t])=><button type="button" aria-pressed={period===v} className={period===v?'mp-promo-selected':''} key={v} onClick={()=>{manualPeriodRef.current=true;setPeriod(v)}}>{t}</button>)}
              </div>
              {period!=='all'&&<div className="mp-promo-calendar-control">
                <span className="mp-promo-calendar-icon" aria-hidden="true">▦</span>
                {period==='range'?<input aria-label="Rango de fechas" ref={rangeRef} readOnly placeholder="Seleccionar rango"/>:<input aria-label="Seleccionar día" ref={dayRef} readOnly placeholder="Seleccionar fecha"/>}
              </div>}
              {period!=='all'&&<button type="button" className="mp-promo-clear-date" onClick={()=>{manualPeriodRef.current=true;setPeriod('all')}}>Quitar fecha</button>}
            </div>
          </div>
          <label className="mp-promo-search-field">BUSCAR<input value={search} onChange={e=>setSearch(e.target.value)} placeholder="Cliente, asesor, campaña, regalo, MERCH..."/></label>
        </div>
        <div className="mp-promo-filter-bottom">
          <label>SEDE<select value={sedeFilter} onChange={e=>setSedeFilter(e.target.value)}><option value="">Todas</option>{sedes.map(x=><option key={x.sd_id||x.id} value={x.sd_id||x.id}>{x.sd_sede||x.sd_name||x.name}</option>)}</select></label>
          <label>ASESOR<select value={advisorFilter} onChange={e=>setAdvisorFilter(e.target.value)}><option value="">Todos</option>{filterOptions.advisors.map(x=><option key={x.id} value={x.id}>{x.name}</option>)}</select></label>
          <label>RUC<select value={rucFilter} onChange={e=>setRucFilter(e.target.value)}><option value="">Todos</option>{filterOptions.rucs.map(x=><option key={x.id} value={x.id}>{x.name}</option>)}</select></label>
          <label>CATEGORÍA<select value={categoryFilter} onChange={e=>setCategoryFilter(e.target.value)}><option value="">Todas</option>{filterOptions.categories.map(x=><option key={x.id} value={x.id}>{x.name}</option>)}</select></label>
          <label>PROVEEDOR<select value={supplierFilter} onChange={e=>setSupplierFilter(e.target.value)}><option value="">Todos</option>{filterOptions.suppliers.map(x=><option key={x.id} value={x.id}>{x.name}</option>)}</select></label>
        </div>
      </div>
      {error && (
        <p className="mp-promotions-error" role="alert">
          {error}
        </p>
      )}
      {notice && (
        <p className="mp-promotions-ok" role="status">
          {notice}
        </p>
      )}
      {createOpen&&<div className="mp-promo-overlay" onMouseDown={e=>{if(e.target===e.currentTarget)setCreateOpen(false)}}><div className="mp-promo-dialog" role="dialog" aria-modal="true" aria-label="Nueva campaña"><div className="mp-promo-dialog-head"><strong>Nueva campaña promocional</strong><button type="button" onClick={()=>setCreateOpen(false)}>Cerrar</button></div><form onSubmit={submit} className="mp-promotions-form">
        <h3>Nueva campaña</h3>
        <label>
          Nombre
          <input
            maxLength={160}
            value={form.name}
            onChange={(e) => setForm((f) => ({ ...f, name: e.target.value }))}
            required
          />
        </label>
        <div className="mp-promotions-grid">
          <label>
            Inicio
            <input
              ref={startRef}
              type="text"
              readOnly
              placeholder="Seleccionar fecha de inicio"
              required
            />
          </label>
          <label>
            Fin
            <input
              ref={endRef}
              type="text"
              readOnly
              placeholder="Seleccionar fecha de fin"
              required
            />
          </label>
        </div>
        <div className="mp-promotions-grid">
          <label className="mp-promotions-check">
            <input
              type="checkbox"
              checked={form.allow_cash}
              onChange={(e) =>
                setForm((f) => ({ ...f, allow_cash: e.target.checked }))
              }
            />{" "}
            Contado
          </label>
          <label className="mp-promotions-check">
            <input
              type="checkbox"
              checked={form.allow_credit}
              onChange={(e) =>
                setForm((f) => ({ ...f, allow_credit: e.target.checked }))
              }
            />{" "}
            Crédito
          </label>
        </div>
        <fieldset>
          <legend>Sedes participantes</legend>
          <div className="mp-promotions-toolbar"><span>{form.sedes.length} de {sedes.length} sedes seleccionadas</span><button type="button" onClick={()=>setForm(f=>({...f,sedes:allSedesSelected?[]:sedeIds}))}>{allSedesSelected?"Deseleccionar todas":"Seleccionar todas"}</button></div>
          <div className="mp-promotions-options">
            {sedes.map((s) => (
              <label key={s.sd_id || s.id}>
                <input
                  type="checkbox"
                  checked={form.sedes.includes(Number(s.sd_id || s.id))}
                  onChange={() => toggle("sedes", Number(s.sd_id || s.id))}
                />
                {s.sd_name || s.name}
              </label>
            ))}
          </div>
          {!sedes.length && (
            <small>No se encontraron sedes en el catálogo.</small>
          )}
        </fieldset>
        <fieldset>
          <legend>Productos promocionales</legend>
          <div className="mp-promotions-toolbar"><span>{form.products.length} artículos seleccionados · Máximo 4 por venta</span><input aria-label="Buscar productos promocionales" placeholder="Buscar MERCH o REGALOS..." value={productSearch} onChange={e=>setProductSearch(e.target.value)}/></div>
          <div className="mp-promotions-options">
            {filteredProducts.map((p) => (
              <label key={p.id}>
                <input
                  type="checkbox"
                  checked={selected.has(Number(p.id))}
                  onChange={() => toggle("products", Number(p.id))}
                />
                <span><strong>{p.title || p.name}</strong><small>{p.category}</small></span>
              </label>
            ))}
          </div>
          {catalogBusy && <small>Cargando productos promocionales...</small>}
          {!catalogBusy && !products.length && (
            <small>
              El catálogo de productos debe cargar artículos MERCH y REGALOS
              para poder seleccionarlos.
            </small>
          )}
        </fieldset>
        <div className="mp-promotions-submit" role="group" aria-label="Acciones de la campaña">
          <span>Revisa los datos y guarda la campaña. La vigencia incluye el día de finalización.</span>
          <button
            className="mp-promotions-primary mp-promotions-save-button"
            type="submit"
            disabled={busy}
            aria-busy={busy}
            style={{ display: "inline-flex", visibility: "visible", alignItems: "center", justifyContent: "center", minWidth: 190, minHeight: 46, backgroundColor: "#155eef", color: "#ffffff", opacity: busy ? 0.65 : 1 }}
          >
            {busy ? "Guardando..." : "Crear campaña"}
          </button>
        </div>
      </form></div></div>}
      <div className="mp-promo-return-card">
        <div className="mp-promo-return-copy">
          <span className="mp-promo-eyebrow">CONTROL DE INVENTARIO</span>
          <h3>Devoluciones físicas</h3>
          <p>Confirma la recepción de obsequios después de una nota de crédito aceptada. El stock se reincorpora mediante el flujo de devolución existente.</p>
        </div>
        <button type="button" className="mp-promo-return-button" onClick={()=>setReturnOpen(true)}>Gestionar devoluciones <span aria-hidden="true">→</span></button>
      </div>
      {returnOpen && <PromotionGiftReturnModal onClose={()=>setReturnOpen(false)}/>}
      <section className="mp-promo-campaigns" aria-label="Campañas registradas">
        <div className="mp-promo-campaigns-head">
          <div><span className="mp-promo-eyebrow">ADMINISTRACIÓN DE CAMPAÑAS</span><h3>Campañas registradas</h3><p>Consulta las campañas por estado y revisa sus entregas sin salir de esta página.</p></div>
          <span className="mp-promo-campaign-total">{filteredItems.length} {filteredItems.length===1?'campaña':'campañas'} en esta vista</span>
        </div>
        <div className="mp-promo-tabs" role="group" aria-label="Filtrar campañas por estado">
          {[['ACTIVE','Activas'],['PAUSED','Pausadas'],['CLOSED','Finalizadas'],['DRAFT','Borradores']].map(([v,t])=><button type="button" key={v} aria-pressed={tab===v} className={tab===v?'mp-promo-selected':''} onClick={()=>setTab(v)}>{t}<span className="mp-promo-tab-count">{items.filter(p=>p.status===v).length}</span></button>)}
        </div>
        <div className="mp-promotions-list mp-promo-campaign-list">
          {filteredItems.map((p) => (
            <article key={p.id} className="mp-promo-campaign-card">
              <div className="mp-promo-campaign-main">
                <div className="mp-promo-campaign-title"><strong>{p.name}</strong><span className={`mp-promo-status mp-promo-status-${p.status.toLowerCase()}`}>{({ACTIVE:'Activa',PAUSED:'Pausada',CLOSED:'Finalizada',DRAFT:'Borrador'})[p.status]||p.status}</span></div>
                <div className="mp-promo-campaign-meta">
                  <span><b>Vigencia</b> {String(p.starts_at||'').slice(0,10)} — {String(p.ends_at||'').slice(0,10)}</span>
                  <span><b>Sedes</b> {p.sedes?.length||0}</span>
                  <span><b>Productos</b> {p.products?.length||0}</span>
                </div>
              </div>
              <div className="mp-promo-campaign-actions">
                <button type="button" className="mp-promo-report-button" onClick={()=>{setReport(null);setReportCampaign(p)}}>Ver reporte <span aria-hidden="true">↗</span></button>
                <label className="mp-promo-status-control"><span>Cambiar estado</span><select disabled={busy} aria-label={`Cambiar estado de ${p.name}`} value={p.status} onChange={(e)=>status(p.id,e.target.value)}>
                  <option value="ACTIVE">Activa</option><option value="PAUSED">Pausada</option><option value="CLOSED">Finalizada</option><option value="DRAFT">Borrador</option>
                </select></label>
              </div>
            </article>
          ))}
          {!filteredItems.length && <div className="mp-promo-empty"><strong>No hay campañas para mostrar</strong><p>Prueba otro estado o modifica el período de consulta.</p></div>}
        </div>
      </section>
       {reportCampaign && <div className="mp-promo-overlay" onMouseDown={e=>{if(e.target===e.currentTarget)setReportCampaign(null)}}>
         <div className="mp-promo-dialog mp-promo-report mp-promo-report-v2" role="dialog" aria-modal="true" aria-label={`Reporte de ${reportCampaign.name}`}>
           <div className="mp-promo-dialog-head mp-promo-report-head">
             <div className="mp-promo-report-heading">
               <span className="mp-promo-report-kicker">SEGUIMIENTO DE CAMPAÑA</span>
               <h2>Reporte de {reportCampaign.name}</h2>
               <p>Consulta los obsequios entregados, devueltos y anulados según los filtros de la página.</p>
               <span className="mp-promo-live-label"><span aria-hidden="true" className="mp-promo-live-dot"/> Actualización automática cada 20 segundos</span>
             </div>
             <div className="mp-promo-actions mp-promo-report-actions">
               <button type="button" onClick={()=>fetchReport(reportCampaign.id,reportParams)}>Actualizar datos</button>
               <button type="button" className="mp-promo-report-export" onClick={exportReport} disabled={!report || !!reportError}>Descargar Excel</button>
               <button type="button" onClick={()=>setReportCampaign(null)} aria-label="Cerrar reporte">Cerrar</button>
             </div>
           </div>
           {reportError && <p role="alert" className="mp-promotions-error mp-promo-report-alert">{reportError}</p>}
           {!report && !reportError && <div className="mp-promo-report-loading" role="status">Consultando el reporte de la campaña…</div>}
           {report && <div className="mp-promo-report-body">
             <div className="mp-promo-report-section-head"><div><h3>Resumen de obsequios</h3><p>Las cifras representan unidades de productos, no ventas ni importes.</p></div></div>
             <div className="mp-promo-metrics mp-promo-metrics-v2">
               {[
                 {key:'delivered',label:'Entregados',hint:'Unidades registradas como entregadas a clientes.',style:'delivered'},
                 {key:'returned',label:'Devueltos',hint:'Unidades con devolución registrada.',style:'returned'},
                 {key:'voided',label:'Anulados',hint:'Unidades correspondientes a operaciones anuladas.',style:'voided'},
                 {key:'net',label:'Netos',hint:'Unidades que permanecen entregadas según el reporte.',style:'net'}
               ].map(metric=><div className={`mp-promo-metric mp-promo-metric-${metric.style}`} key={metric.key}>
                 <div className="mp-promo-metric-label"><span>{metric.label}</span><span className="mp-promo-metric-help" title={metric.hint} aria-label={metric.hint}>i</span></div>
                 <strong>{Number(report.summary?.[metric.key] ?? 0).toLocaleString('es-PE')}</strong>
                 <p>{metric.hint}</p>
               </div>)}
             </div>
             <div className="mp-promo-report-section-head mp-promo-detail-heading">
               <div><h3>Detalle de entregas</h3><p>Identifica cada movimiento por fecha, cliente, asesor, sede y producto.</p></div>
               <span className="mp-promo-report-count">{report.rows?.length || 0} registros</span>
             </div>
             <div className="mp-promo-table mp-promo-table-v2">
               <table><thead><tr>{['Fecha','Cliente','Asesor','Sede','RUC','Producto','Cantidad','Estado'].map(x=><th key={x} scope="col">{x}</th>)}</tr></thead>
               <tbody>{(report.rows || []).map((r,index)=><tr key={`${r.id ?? r.register_id ?? 'fila'}-${index}`}>
                 <td>{String(r.created_at || '').slice(0,19).replace('T',' ') || '—'}</td>
                 <td>{r.customer || '—'}</td><td>{r.advisor || '—'}</td><td>{r.sede || '—'}</td>
                 <td>{r.issuer || 'Sin comprobante'}</td><td>{r.product || '—'}</td>
                 <td className="mp-promo-quantity">{r.quantity ?? 0}</td>
                 <td><span className={`mp-promo-row-status mp-promo-row-status-${String(r.status || '').toLowerCase()}`}>{({DELIVERED:'Entregado',RETURNED:'Devuelto',VOIDED:'Anulado'})[r.status] || r.status || 'Sin estado'}</span></td>
               </tr>)}</tbody></table>
               {!report.rows?.length && <div className="mp-promo-report-empty"><strong>No hay entregas para los filtros seleccionados</strong><p>Prueba con otro período, sede, asesor, RUC, categoría o proveedor.</p></div>}
             </div>
             <p className="mp-promo-report-footnote">Los totales y el archivo Excel se obtienen del reporte existente. Las devoluciones y anulaciones se contabilizan según los estados registrados en el sistema.</p>
           </div>}
         </div>
       </div>}
    </section>
  );
}
